// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__DpLb3","inputWrap":"styles_inputWrap__1gZNv","input":"styles_input__1mr4d"};